import { Observable, Observer } from "rxjs";
import { HTTP_METHOD } from "../../constants/http";
import { AxiosSubscriber } from "../AxiosSubscriber";
import { IApplicationComponentTypeModel } from "../../models";

export class ApplicationComponentTypeService {
  get url(): string {
    return "/ApplicationsComponentsTypes";
  }

  public select = (): Observable<IApplicationComponentTypeModel[]> =>
    new Observable(
      (observer: Observer<IApplicationComponentTypeModel[]>) =>
        new AxiosSubscriber(observer, {
          method: HTTP_METHOD.GET,
          url: `${this.url}/Select`,
        })
    );
}
